import * as React from 'react';

import { useCustomMutation, useInvalidate, useNavigation, useNotification } from '@refinedev/core';

import { resourceNames } from '~/resources/resource-names';

export const usePendingPaymentVerificationOrder = () => {
  const { open } = useNotification();
  const customMutation = useCustomMutation();
  const invalidate = useInvalidate();
  const { list: navigateToList } = useNavigation();

  const mutate = React.useCallback((id?: string) => {
    customMutation.mutate(
      {
        method: 'post',
        url: '',
        values: {},
        metaData: {
          operation: 'markOrderPendingPaymentVerification',
          fields: ['id', 'status'],
          variables: {
            id: {
              type: 'String',
              required: true,
              value: id,
            },
          },
        },
      },
      {
        onSuccess: () => {
          open?.({
            key: `${id}${new Date().getTime()}`,
            type: 'success',
            message: 'Order marked as pending payment verification',
          });
          invalidate({
            resource: resourceNames.order,
            invalidates: ['list'],
          });
          navigateToList(resourceNames.order);
        },
      }
    );
  }, []);

  return {
    ...customMutation,
    mutate,
  };
};
